import styled from "styled-components";

export const CardHomeContent = styled.div.attrs({})`
  width: 100%;
  padding: 16px 24px;
  border-bottom: 1px solid ${(p) => p.theme.palette.colors.disabledgrey};
  background: ${(props) => props.theme.palette.colors.white};

  box-shadow: 0px 3px 6px ${(p) => p.theme.palette.colors.shadow};

  @media (max-width: 500px) {
    padding: 16px;
  };

  @media (max-width: 380px) {
    padding: 16px 8px;
  };
`;

export const CardHomeContentHeader = styled.div.attrs({})`
  display: flex;
  justify-content: flex-end;
  padding: 0 0 12px;
`;
export const CardHomeContentLabel = styled.div.attrs({})`
  padding: 4px 16px 4px 8px;
  background: ${(props) =>
    props.isSuccess
      ? props.theme.palette.colors.greenLight
      : props.theme.palette.colors.purpleLight};
  border-radius: 32px;
  display: flex;
  align-items: center;
`;
export const CardHomeContentLabelDecoration = styled.img.attrs((props) => ({
  src: props.isSuccess ? "/icons/approved.svg" : "/icons/info.svg",
}))`
  width: 13px;
  height: 13px;
  margin: 0 8px 0 0;
`;
export const CardHomeContentLabelText = styled.div.attrs({})`
  font-size: 14px;
  color: ${(props) =>
    props.isSuccess
      ? props.theme.palette.colors.green
      : props.theme.palette.colors.blue};

  @media (max-width: 1050px) {
    font-size: 12px;
  }
`;
export const CardHomeContentBody = styled.div.attrs({})`
  display: flex;
  align-items: center;
`;
export const CardHomeContentBodyTitle = styled.div.attrs({})`
  font-size: 18px;
  color: ${(props) => props.theme.palette.colors.black};
`;
export const CardHomeContentBodyText = styled.div.attrs({})`
  font-size: 14px;
  color: ${(props) => props.theme.palette.colors.text};
  margin: 8px 0 16px 0px;
`;
export const CardHomeContentBodyActions = styled.div.attrs({})`
  padding: 8px 0 0;
  display: flex;
`;
export const CardDashboardCampaignTrashIcon = styled.img.attrs({
  src: "/icons/trash-2.svg",
  width: 16,
})`
  &:hover {
    cursor: pointer;
  }
`;
export const CardHomeContentBodyAction = styled.div.attrs({})`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 25px;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
    gap: 16px;
  }
`;

export const CardDashboardCampaignMoreDetails = styled.div.attrs({})`
  color: ${(props) => props.theme.palette.secondary.main};
  &:hover {
    cursor: pointer;
  }

  @media (max-width: 1050px) {
    margin-left: 0px;
    margin-right: 0px;
  }

  @media (max-width: 450px) {
    font-size: 14px;
  }
`;
export const CardDashboardCampaignUserImage = styled.div.attrs({})`
  width: 56px;
  height: 56px;
  border-radius: 28px;

  background: ${(p) => p.theme.palette.colors.lightprimary}
    url(${(p) => p.image}) no-repeat center center / cover;

  display: flex;
  align-items: center;
  justify-content: center;
`;
export const CardDashboardCampaignUserImageText = styled.div.attrs({})`
  font-size: 24px;
  color: ${(p) => p.theme.palette.colors.text};
`;

export const CardDashboardCampaignDetailsContainer = styled.div.attrs({})`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-left: 16px;

  @media (max-width: 1050px) {
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }
`;

export const CardDashboardCampaignActionContainer = styled.div.attrs({})`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 25px;

  @media (max-width: 1050px) {
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  @media (max-width: 375px) {
    margin-left: -16px;
  }
`;
